<template lang="html">
  <div>
  <v-list two-line avatar :class="add_user?'scroll':''">
    <v-list-item v-for="(member, index) in members" :key="index"
    @click="$emit('selectIndex', index)"
    :style="selected_index === index? 'background-color: #616161':''">
      <v-list-item-avatar color="grey">
        <v-img v-if="member.image !== 'noimage'" :src="member.image" />
        <span v-else class="white--text pl-2">{{member.first_name[0].toUpperCase() + member.last_name[0].toUpperCase()}}</span>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>{{ member.first_name + ' ' + member.last_name}} {{member.email === current_user.email ? '(You)':''}}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-list>
  <v-list>
    <slot name="add-member" />
  </v-list>
  </div>
</template>
<script>
export default {
  props: ['members', 'current_user', 'selected_index', 'add_user'],
  methods: {
  }
}
</script>
<style>
  .scroll{
  height:495px;
  overflow-y:auto;
  }
</style>
